import axios from 'axios'
import { getApiBaseUrl } from 'config'
import { getCurrentUser, setCurrentUser } from 'utils/authStorage'


const REACT_APP_D_CORE_URL = getApiBaseUrl()


export const refreshToken = async () => {
  const currentUser = getCurrentUser()
  if (!currentUser?.token?.refresh_token) return null

  return await axios
    .get(`${REACT_APP_D_CORE_URL}/auth/v1/refresh_token`, {
      headers: {
        Authorization: `Bearer ${currentUser.token.refresh_token}`,
        'X-Channel': 'INTERNET_BANKING',
      },
    })
    .then((response: any) => {
      setCurrentUser({
        ...currentUser,
        token: {
          ...currentUser.token,
          access_token: response.data?.access_token,
          refresh_token: response.data?.refresh_token,
        },
      })
      return response
    })
    .catch((error) => error.response?.data)
}
